import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { useFormik } from 'formik'
import { ApplicationState } from '@/state'
import useDialog from '@/hooks/ui/use-dialog.hook'

import { getValidationString } from '@/utils'
import { usePlayerCardActions } from './'

export const usePlayerKYCStatusForm = () => {
  const { updateKYCStatus } = usePlayerCardActions()

  const { handleCloseDialog, dialog } = useDialog()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const initialValuesKYCStatus = {
    kycStatus: playerCard?.kycStatus || '',
    comment: '',
  }

  const validationSchemaKYCStatus = Yup.object().shape({
    comment: getValidationString({ required: true }),
  })

  const formikKYCStatus = useFormik({
    initialValues: initialValuesKYCStatus,
    validationSchema: validationSchemaKYCStatus,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const handleSubmit = () => {
    updateKYCStatus({
      playerId: playerCard.id,
      kycStatus: formikKYCStatus.values.kycStatus,
      comment: formikKYCStatus.values.comment,
    })
  }

  useEffect(() => {
    formikKYCStatus.resetForm()
  }, [dialog]) // eslint-disable-line

  return {
    dialog,
    formikKYCStatus,
    handleSubmit,
    handleCloseDialog,
  }
}
